import { ErrorBoundary } from "@sentry/react";
import { PropsWithChildren } from "react";
import { RequiresAuthenticationIf } from "../authentication/core/components/requires-authentication-if.component";
import { CampingRentErrorReset } from "./components/camping-rent-error-reset.component";
import { useCampingStation } from "./hooks/use-camping-station";
import { useCampingStationSlug } from "./hooks/use-camping-station-slug";

export const CampingRentErrorBoundary: React.FC<PropsWithChildren> = ({
  children,
}) => (
  <ErrorBoundary fallback={<CampingRentErrorReset />}>
    {children}
  </ErrorBoundary>
);

export const CampingRentRoot: React.FC<PropsWithChildren> = ({ children }) => {
  const station = useCampingStation();
  const stationSlug = useCampingStationSlug();

  return (
    <RequiresAuthenticationIf
      requiresAuthentication={station.requiresLogin}
      allowedEmailDomains={station.allowedEmailDomains}
      stationSlug={stationSlug}
    >
      {children}
    </RequiresAuthenticationIf>
  );
};
